import { RegisterOptions, useFormContext } from 'react-hook-form'

import InputLabel from '@atoms/InputLabel'

import * as style from './style.module.sass'

type TextAreaInputProps = {
  name: string
  label?: string
  registerOptions?: RegisterOptions
  placeholder?: string
  errorMessage?: string
  className?: string
}
const TextAreaInput = ({
  name,
  label,
  registerOptions = {},
  placeholder,
  errorMessage,
  className,
}: TextAreaInputProps) => {
  const { register } = useFormContext()

  return (
    <label className={`${style.textInput} ${className}`}>
      {label !== undefined && (
        <InputLabel
          label={label}
          required={registerOptions.required === true}
          design="large"
        />
      )}
      <textarea
        placeholder={placeholder}
        {...register(name, registerOptions)}
        data-error={errorMessage !== undefined}
      />
      {errorMessage !== undefined && (
        <div className={style.errorMessage}>{errorMessage}</div>
      )}
    </label>
  )
}

export default TextAreaInput
